// src/components/CashGateModal.js
// Shown when customer selects Cash payment on a QR order
// Forces acknowledgement before order is placed
// Reduces food wastage from orders not collected/paid

import React, { useState } from 'react';

export default function CashGateModal({ orderTotal, onConfirm, onCancel }) {
  const [confirmed, setConfirmed] = useState(false);

  return (
    <div style={{
      position: 'fixed', inset: 0,
      background: 'rgba(0,0,0,0.88)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 2000, padding: 24,
    }}>
      <div style={{
        background: 'var(--bg2)',
        border: '1px solid var(--border)',
        borderRadius: 18, width: '100%', maxWidth: 420,
        overflow: 'hidden',
      }}>
        {/* Header */}
        <div style={{
          background: '#3d2e10',
          borderBottom: '1px solid var(--accent)',
          padding: '20px 24px',
          textAlign: 'center',
        }}>
          <div style={{ fontSize: 48, marginBottom: 8 }}>💵</div>
          <div style={{ fontSize: 20, fontWeight: 700, color: 'var(--accent)' }}>
            Cash Payment Selected
          </div>
        </div>

        <div style={{ padding: '24px 24px 20px' }}>
          {/* Instructions */}
          <div style={{
            background: 'var(--bg3)', borderRadius: 10,
            padding: '14px 16px', marginBottom: 20,
          }}>
            <div style={{ fontWeight: 700, fontSize: 14, color: 'var(--text)', marginBottom: 10 }}>
              To complete your order:
            </div>
            {[
              { icon: '1️⃣', text: 'Your order will be placed now' },
              { icon: '2️⃣', text: 'Go to the stall counter immediately' },
              { icon: '3️⃣', text: 'Show your order number and pay cash' },
              { icon: '4️⃣', text: 'Your food will be prepared after payment' },
            ].map(({ icon, text }) => (
              <div key={icon} style={{
                display: 'flex', alignItems: 'center', gap: 10,
                marginBottom: 8, fontSize: 14, color: 'var(--text2)',
              }}>
                <span>{icon}</span><span>{text}</span>
              </div>
            ))}
          </div>

          {/* Warning */}
          <div style={{
            background: '#3d1a1a', border: '1px solid var(--red)',
            borderRadius: 8, padding: '10px 14px', marginBottom: 20,
            fontSize: 13, color: 'var(--red)',
          }}>
            ⚠️ Orders not paid at the counter will be cancelled.
            Please go to the counter <strong>before</strong> food preparation begins.
          </div>

          {/* Total */}
          <div style={{
            display: 'flex', justifyContent: 'space-between',
            alignItems: 'center', marginBottom: 20,
            padding: '12px 0', borderTop: '1px solid var(--border)',
          }}>
            <span style={{ fontSize: 14, color: 'var(--text2)' }}>Amount to pay at counter</span>
            <span style={{ fontSize: 22, fontWeight: 700, color: 'var(--accent)' }}>
              AED {Number(orderTotal).toFixed(2)}
            </span>
          </div>

          {/* Confirmation checkbox */}
          <label style={{
            display: 'flex', alignItems: 'flex-start', gap: 12,
            cursor: 'pointer', marginBottom: 20,
          }}>
            <input
              type="checkbox"
              checked={confirmed}
              onChange={e => setConfirmed(e.target.checked)}
              style={{ width: 18, height: 18, marginTop: 2, cursor: 'pointer' }}
            />
            <span style={{ fontSize: 13, color: 'var(--text2)', lineHeight: 1.5 }}>
              I understand I must go to the counter and pay cash before my order is prepared.
            </span>
          </label>

          {/* Buttons */}
          <div style={{ display: 'flex', gap: 10 }}>
            <button
              className="btn btn-ghost"
              style={{ flex: 1 }}
              onClick={onCancel}>
              ← Change Payment
            </button>
            <button
              className="btn btn-primary"
              style={{ flex: 2, padding: 13, opacity: confirmed ? 1 : 0.5 }}
              disabled={!confirmed}
              onClick={onConfirm}>
              ✓ Place Order
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
